import React from 'react'
// hooks
import { useModalData } from 'hooks'
// constants
import { Modals } from 'constants/modals'
// context
import { PlansPageContext } from 'containers/Plan/Register/layers/API'
import { TableManagementContext } from 'containers/Search/layers/BL'
// view components
import { Table } from 'components/UI'
// components
import Row from './components/Row'
import ConfirmDeleteModal from 'components/Modals/ConfirmDeleteModal'
import CreateSubPlanModal from 'components/Modals/CreateSubPlanModal'
// utils
import { getTableHeader } from 'utils'

const PlansTable = () => {
  const { handleSetPage, handleSetPerPage, page, perPage } = React.useContext(TableManagementContext)
  const { data, fields, totalCount, refetch, isRefetching } = React.useContext(PlansPageContext)

  const {
    modalData: { entity }
  } = useModalData({ modalType: Modals.CONFIRM_DELETE_MODAL })

  const headers = [
    { id: 'plan.name', sortable: true, left: true, label: getTableHeader('planTitle', fields, 'PLAN TITLE') },
    { id: 'plan.status', sortable: true, left: true, label: getTableHeader('status', fields, 'STATUS') },
    { id: 'plan.planType', sortable: true, left: true, label: getTableHeader('planType', fields, 'PLAN TYPE') },
    { id: 'nextReview', sortable: false, left: true, label: 'NEXT REVIEW' },
    {
      id: 'plan.ownedById',
      sortable: true,
      left: true,
      label: getTableHeader('ownedByEmployeeOrPosition', fields, 'OWNED BY')
    },
    { id: 'actions', left: true }
  ]

  return (
    <>
      <Table
        data={data}
        page={page}
        title='Plans'
        headers={headers}
        perPage={perPage}
        refetch={refetch}
        totalCount={totalCount}
        isLoading={isRefetching}
        onPageChange={handleSetPage}
        onPerPageChange={handleSetPerPage}>
        {({ data }) => data.map((item) => <Row key={item.id} data={item} />)}
      </Table>

      <CreateSubPlanModal />
      <ConfirmDeleteModal header={`Delete ${entity}`}>
        Are you sure want to delete this plan? This will also <b>delete</b> any associated records such as sub-plans,
        objectives, actions and indicators.
      </ConfirmDeleteModal>
    </>
  )
}

export default PlansTable
